import React from 'react'

export default function Button2({children,type='light', onClickFunc,disabled,minWidth,id}) {
    const buttonLightStyle={
        minWidh:'96px',
        border: '1px solid #E0E2E6',
        padding:'8px 16px 8px 16px',
        borderRadius: '8px',
        boxShadow:' 0px 1px 2px 0px #1018280D',
        fontSize:'14px',
        color:'#2A364A',
        // marginRight:'8px',
        background:'#FFFFFF',
        fontWeight:'400',
        cursor:'pointer',
        display:'flex',
        alignItems:'center',
        minWidth: `${minWidth}`,
        cursor:disabled ? 'not-allowed' :'pointer',
    }
    const buttonDarkStyle={
        minWidh:'96px',
        border: '1px solid #E0E2E6',
        padding:'8px 16px 8px 16px',
        borderRadius: '8px',
        boxShadow:' 0px 1px 2px 0px #1018280D',
        fontSize:'14px',
        color:'#2A364A',
        // marginRight:'8px',
        background:'#F6F7F8',
        fontWeight:'400',
        cursor:disabled ? 'not-allowed' :'pointer',
        display:'flex',
        alignItems:'center',
        minWidth:`${minWidth}`,
        ...(minWidth !== undefined && { justifyContent:'center'})
    }
  return (
    <div id={id}  style={type==='light'?buttonLightStyle:buttonDarkStyle} onClick={()=>onClickFunc()}>{children}</div>
  )
}
